/**
 * First URL segments that must not be treated as tenant portal slugs (avoids shadowing app routes).
 */
const RESERVED = new Set(
  [
    'admin',
    'tenant',
    'client',
    'login',
    'portal',
    'features',
    'pricing',
    'about',
    'signup',
    'onboarding',
    'reset-password',
    'api',
    'static',
    'assets',
    'p',
    'favicon.ico',
  ].map((s) => s.toLowerCase())
);

export function isReservedPortalSlug(segment) {
  if (!segment || typeof segment !== 'string') return true;
  return RESERVED.has(segment.trim().toLowerCase());
}
